import axios from 'axios';

// httpOnly cookies set by the backend carry the session; `withCredentials`
// ensures they flow with every request. Auth tokens are no longer stored in
// localStorage (which is XSS-readable).
const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,
});

// Handle 401 responses — auto-refresh via cookie-backed endpoint
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401 && !error.config._retry) {
      error.config._retry = true;
      try {
        await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/auth/refresh`,
          {},
          { withCredentials: true }
        );
        return api(error.config);
      } catch (err) {
        console.warn('[auth] token refresh failed', err);
      }
    }
    return Promise.reject(error);
  }
);

export default api;

export function formatApiError(detail) {
  if (detail == null) return 'Something went wrong. Please try again.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e?.msg || JSON.stringify(e))).filter(Boolean).join(' ');
  if (detail?.msg) return detail.msg;
  return String(detail);
}
